import type { Rule } from "antd/es/form"

/** `whitespace` is what rejects a box holding only spaces; `required` alone accepts them. */
export const lossReasonRules = (message: string): Rule[] => [
  { required: true, whitespace: true, message }
]
